<div id="pdp-stylitics-component"
    class="hmf-mt-0"
    [ngClass]="showHeader ? 'hmf-mb-l hmf-mb-m-xl' : ''">
        <div id="stylitics-header-container" *ngIf="showHeader">
            <h2 class="stylitics-header description-header hmf-flex-grow">Complete The Set</h2>
            <hr/>
        </div>
    <div id="pdp-stylitics-target"></div>
</div>
